import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { getDocuments } from "@/api/v1-jwt/provider-onboarding/provider-onboarding";
import { DocumentsResponse } from "./types";
import providerOnboardingQueryKeys from "./query-keys";

export const useDocuments = (
  userId: string,
  applicationId: string,
  providerType: string,
  options?: Omit<UseQueryOptions<DocumentsResponse, Error>, "queryKey" | "queryFn">
) => {
  return useQuery<DocumentsResponse, Error>({
    queryKey: providerOnboardingQueryKeys.documents(userId, applicationId, providerType),
    queryFn: () => getDocuments(userId, applicationId, providerType),
    enabled: !!userId && !!applicationId && !!providerType,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    ...options,
  });
};
